import {
  MobileProxiesVisual,
  ResidentialProxiesVisual,
  DatacenterProxiesVisual,
  IspProxiesVisual,
} from "@/components/sections/home/products-overview/data";

export type WaitlistTarget = "datacenter" | "isp";

type BaseProduct = {
  id: string;
  Visual: React.ComponentType<{ reduced: boolean; hovered: boolean }>;
  name: string;
  description: string;
  bullets: string[];
  cta: string;
  badge: string | null;
  startingPrice: string | null;
};

export type PricingProduct =
  | (BaseProduct & { href: string; waitlist?: never })
  | (BaseProduct & { waitlist: WaitlistTarget; href?: never });

export const pricingProducts: PricingProduct[] = [
  {
    id: "mobile",
    Visual: MobileProxiesVisual,
    name: "Mobile Proxies",
    description: "Premium 4G/5G IPs, ethically sourced and fully compliant.",
    bullets: ["Premium pooled mobile IPs", "City and ASN/ISP targeting", "99.5%+ success rate"],
    href: "/mobile-proxy-pricing",
    cta: "View pricing",
    badge: null,
    startingPrice: "From $2/GB",
  },
  {
    id: "residential",
    Visual: ResidentialProxiesVisual,
    name: "Residential Proxies",
    description: "Ethically sourced residential IPs across 195+ countries",
    bullets: [
      "195+ countries with city-level targeting",
      "HTTPS & SOCKS5 support",
      "Bandwidth rollover, no wasted GBs",
    ],
    href: "/residential-proxies-pricing",
    cta: "View pricing",
    badge: null,
    startingPrice: "From $1/GB",
  },
  {
    id: "isp",
    Visual: IspProxiesVisual,
    name: "ISP Proxies",
    description:
      "Static residential IPs hosted on datacenter infrastructure — speed plus authenticity.",
    bullets: ["Sticky long-lived sessions", "Residential trust scores", "Datacenter speeds"],
    waitlist: "isp",
    cta: "Join waiting list",
    badge: "Coming Soon",
    startingPrice: null,
  },
  {
    id: "datacenter",
    Visual: DatacenterProxiesVisual,
    name: "Datacenter Proxies",
    description:
      "High-speed datacenter IPs from Tier-IV facilities, built for volume at a lower cost per IP.",
    bullets: [
      "1 Gbps speeds with 99.9% target uptime",
      "IPv4 & IPv6 across global regions",
      "HTTPS & SOCKS5 support",
    ],
    waitlist: "datacenter",
    cta: "Join waiting list",
    badge: "Coming Soon",
    startingPrice: null,
  },
];

export const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12 } },
};

export const cardVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};
